import { Component, EventEmitter, Output, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'register-an-account',
  templateUrl: './register-an-account.component.html',
  styleUrls: ['./register-an-account.component.scss']
})
export class RegisterAnAccountComponent {
  @Input() alreadySubscriber: boolean = false;
  @Output() onSubmit = new EventEmitter<{ password: string, subscribedOnNews: boolean }>();

  public hidePassword: boolean = true;
  public password: string;
  public subscribedOnNews: boolean = false;

  public submit() {
    this.onSubmit.emit({
      password: this.password,
      subscribedOnNews: this.subscribedOnNews
    });
  }
}